/* Pure query-string logic for useAdminUrlState.js, split into its own module
   with no react-router-dom import so it can be unit-tested directly — Jest in
   this project can't load anything that imports react-router-dom (see the
   note on App.test.js in CLAUDE.md), and useAdminUrlState.js itself does. */

/* colArrival/colDeparture/sQuery get shorter URL keys — everything else keeps
   its own name. */
export const SUMMARY_FILTER_KEY_MAP = { colArrival: "c_arr", colDeparture: "c_dep", sQuery: "s_q" };

/* Parses the URL's query string into the shape every admin component reads,
   with every default already applied. */
export function parseAdminParams(searchParams) {
  return {
    tab: searchParams.get("tab") || "summary",
    calendar: searchParams.get("calendar") === "1",
    b: searchParams.get("b") || null,
    view: searchParams.get("view") === "1",
    room: searchParams.get("room") || null,
    ghSub: searchParams.get("gh_sub") || "",
    stat: searchParams.get("stat") || "All",
    month: searchParams.get("month") || "",
    btype: searchParams.get("btype") || "All",
    day: searchParams.get("day") || "",
    colArrival: searchParams.get("c_arr") || "",
    colDeparture: searchParams.get("c_dep") || "",
    sQuery: searchParams.get("s_q") || "",
    status: searchParams.get("status") || "All",
    gh: searchParams.get("gh") || "All",
    q: searchParams.get("q") || "",
    fdQuery: searchParams.get("fd_q") || "",
    from: searchParams.get("from") || "",
    to: searchParams.get("to") || "",
    date: searchParams.get("date") || "",
  };
}

/* Applies `updates` onto a copy of `searchParams`: null/undefined/"" deletes
   the key (clearing a filter), anything else sets it (stringified). Every
   setter in useAdminUrlState funnels through this — it's the one place that
   decides what "clearing" a query param means. */
export function applyParamPatch(searchParams, updates) {
  const next = new URLSearchParams(searchParams);
  for (const [key, value] of Object.entries(updates)) {
    if (value === null || value === undefined || value === "") {
      next.delete(key);
    } else {
      next.set(key, String(value));
    }
  }
  return next;
}

/* SummaryTab's onFilterChange callback takes the same field names `params`
   exposes (colArrival, colDeparture, sQuery); this renames them onto their
   short URL keys before they reach applyParamPatch. */
export function mapSummaryFilterKeys(patch) {
  const mapped = {};
  for (const [k, v] of Object.entries(patch)) mapped[SUMMARY_FILTER_KEY_MAP[k] || k] = v;
  return mapped;
}
